import React from "react";

const defaultRiskOpportunityData = [
  {
    sno: "1",
    ro: "",
    description: "",
    timeHorizon: "",
    timeHorizonDefinition: "",
    comments: "",
  },
];

const RiskOpportunityTable = ({
  riskOpportunityData,
  setRiskOpportunityData,
}) => {
  const renumberRows = (arr) => arr.map((r, i) => ({ ...r, sno: i + 1 }));

  const handleChange = (index, field, value) => {
    const updated = [...riskOpportunityData];
    updated[index][field] = value;
    setRiskOpportunityData(updated);
  };

  const addRow = () => {
    setRiskOpportunityData([
      ...riskOpportunityData,
      {
        sno: riskOpportunityData.length + 1,
        ro: "",
        description: "",
        timeHorizon: "",
        timeHorizonDefinition: "",
        comments: "",
      },
    ]);
  };

  const removeRow = () => {
    if (riskOpportunityData.length > 1) {
      setRiskOpportunityData(renumberRows(riskOpportunityData.slice(0, -1)));
    }
  };

  // ⬇️ removed border from cells; frame will provide outer border
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const textAreaStyle = {
    ...inputStyle,
    minHeight: "70px",
    resize: "vertical",
  };

  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <>
      {/* ---- styles just for this table; move to a CSS file if you prefer ---- */}
      <style>{`
        .roTableFrame{
          border: 1px solid #000;
          border-radius: 8px;
          overflow: hidden;              /* clips header background into rounded corners */
        }
        .roTable{
          width: 100%;
          border-collapse: collapse;
        }
        .roTable th,
        .roTable td{
          border: 1px solid #000;        /* inner grid lines */
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .roTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide the outer edges so the frame is the only outside border */
        .roTable thead tr:first-child th{ border-top: 0; }
        .roTable tr th:first-child,
        .roTable tr td:first-child{ border-left: 0; }
        .roTable tr th:last-child,
        .roTable tr td:last-child{ border-right: 0; }
        .roTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <div style={{ overflowX: "auto", marginTop: 20 }}>
        {/* ⬇️ the frame that owns the outer border + rounded corners */}
        <div className="roTableFrame">
          <table className="roTable">
            <thead>
              <tr>
                <th style={{ ...header, width: 70 }}>
                  S.
                  <br />
                  NO.
                </th>
                <th style={header}>Risk/Opportunity</th>
                <th style={header}>
                  Description of
                  <br />
                  Risk/Opportunity
                </th>
                <th style={header}>
                  Time Horizon
                  <br />
                  (Short / Medium / Long)
                </th>
                <th style={header}>
                  Definition of
                  <br />
                  Time Horizon
                </th>
                <th style={header}>
                  Comments/Additional
                  <br />
                  Details
                </th>
              </tr>
            </thead>

            <tbody>
              {riskOpportunityData.map((row, index) => (
                <tr key={index}>
                  <td style={cell}>{row.sno || index + 1}.</td>

                  <td style={cell}>
                    <input
                      type="text"
                      placeholder="Enter data"
                      value={row.ro}
                      onChange={(e) =>
                        handleChange(index, "ro", e.target.value)
                      }
                      style={inputStyle}
                    />
                  </td>

                  <td style={cell}>
                    <textarea
                      placeholder="Enter data"
                      value={row.description}
                      onChange={(e) =>
                        handleChange(index, "description", e.target.value)
                      }
                      style={textAreaStyle}
                    />
                  </td>

                  <td style={cell}>
                    <select
                      value={row.timeHorizon}
                      onChange={(e) =>
                        handleChange(index, "timeHorizon", e.target.value)
                      }
                      style={inputStyle}
                    >
                      <option value="">Select</option>
                      <option value="Short">Short</option>
                      <option value="Medium">Medium</option>
                      <option value="Long">Long</option>
                    </select>
                  </td>

                  <td style={cell}>
                    <textarea
                      placeholder="Enter data"
                      value={row.timeHorizonDefinition}
                      onChange={(e) =>
                        handleChange(
                          index,
                          "timeHorizonDefinition",
                          e.target.value
                        )
                      }
                      style={textAreaStyle}
                    />
                  </td>

                  <td style={cell}>
                    <textarea
                      placeholder="Enter data"
                      value={row.comments}
                      onChange={(e) =>
                        handleChange(index, "comments", e.target.value)
                      }
                      style={textAreaStyle}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 10,
            gap: 10,
          }}
        >
          <button onClick={removeRow} style={buttonStyle}>
            - Remove
          </button>
          <button onClick={addRow} style={buttonStyle}>
            + Add More
          </button>
        </div>
      </div>
    </>
  );
};

export default RiskOpportunityTable;
